$( document ).ready(function() {
    var sectionArticles = $('.section-articles');
    var hasSlick = false;
    if ($('body').attr('id') == 'community') {
        hasSlick = updateSlick(hasSlick);
        $(window).on('resize', function () {
            hasSlick = updateSlick(hasSlick);
        });
    }
});
function updateSlick(hasSlick) {
    var sectionArticles = $('.section-articles');
    if ($(window).width() > 768 && hasSlick) {
       sectionArticles.slick('unslick');
        hasSlick = false;
    } else if (!hasSlick && $(window).width() <= 768) {
        sectionArticles.slick({
            dots: true,
            infinite: false,
            arrows: false,
            slidesToShow: 1,
        });
        hasSlick = true;
    }
    return hasSlick;
}